import React, { useState, useEffect, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { getCreditsByMerchantId } from '../api/credits';
import { Images } from '../assets';
import { GoBack } from '../components/back-button';
import { MainContext } from '../components/context/context';
import CreditProductCard from '../components/credit/creditProduct'
import AmountConverter from '../common/amountConverter'
import mixpanel from 'mixpanel-browser';
import { bankpay_consumer_user_id } from '../common/constants';
import { getLocalStorageData } from '../common/resubale-functions';

const CreditDetail = () => {
    const context = useContext(MainContext);
    const { path, setPath } = context;
    const history = useHistory();
    const search = useLocation().search;
    const merchantId = new URLSearchParams(search).get('merchant');
    const [creditsByMerchant, setCreditsByMerchant] = useState([]);
    const [totalRow, setTotalRow] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentBalance, setBalance] = useState(0);
    var event_sent = false;

    useEffect(() => {
        //document.title = 'Credits details';
        setPath(window.location.pathname);
    }, [window.location.pathname]);

    useEffect(() => {
        if (merchantId) handleCredits(merchantId, 1);
    }, [merchantId]);

    const handleCredits = async (merchantId, page) => {
        const res = await getCreditsByMerchantId(merchantId, page);
        //console.log(res?.data.data?.results[0].merchant_store_name,"test result");
        document.title = res?.data.data?.results[0].merchant_store_name + " Credits";
        setCreditsByMerchant(res?.data.data?.results);
        setBalance(res?.data.data?.current_balance);
        
        if (page >= 2) {
            setCreditsByMerchant([...creditsByMerchant, ...res?.data.data?.results]);
        }
        setTotalRow(res?.data.data?.count);
        if (!event_sent) {
            mixpanel.track("Viewed Credit Breakdown", {
                distinct_id: getLocalStorageData(bankpay_consumer_user_id, 'string'),
                merchant_id: merchantId,
                credits_count: res?.data.data?.results?.length,
                credits_total_amount: res?.data.data?.current_balance/100,
                touch_point: "consumer web",
              },
              {send_immediately: true}
            );
            event_sent = true;
        }
    };

    const loadNextPage = () => {
        setCurrentPage(currentPage + 1)
        handleCredits(merchantId, currentPage + 1);
    }

    const redeem = () => {
        window.open(creditsByMerchant[0].merchant_store_url, '_blank');
    }

    const openOrderDetail = (order) => {
        history.push(`/orders?order_id=${order?.checkout_id}`);
    }

    return (
        <>
            <div className="credits-detail-page max-w-[710px] mx-auto py-5 pt-5 flex flex-col hidden lg:block  lg:h-full">
                <div className="credits-detail-page-inner grid grid-cols-1 lg:grid-cols-2 gap-5 lgh-full">
                    <div className="credits-detail-page-inner-left h-full flex flex-col">
                        <div
                            className="page-title text-[32px] font-Rany font-bold grow-0 shrink-0 flex gap-4 items-center pb-4 lg:p-2 lg:pt-0 -mt-2">
                            <GoBack />
                            All Credits
                        </div>
                        <div className="flex gap-4 lg:p-2 flex-col">
                            {creditsByMerchant.map((item, index) => (
                                <CreditProductCard key={'credit_product_' + index} onButtonClick={() => openOrderDetail(item)} order={item} />
                            ))}
                        </div>
                        <div className="shrink-0 text-center pt-6 grow-0">
                            {creditsByMerchant.length < totalRow &&
                                <div onClick={() => loadNextPage()}
                                    className="bg-[#E9ECEF] py-1 px-3 cursor-pointer inline-flex gap-2 items-center rounded-lg hover:bg-[#6C757D] hover:text-white">
                                    See more
                                    <svg className="h-2 w-4" width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.57104 9.32874L15.7638 1.86136C16.0787 1.53369 16.0787 1.00283 15.7638 0.674336C15.4489 0.346673 14.9374 0.346673 14.6225 0.674336L8.0004 7.54941L1.37835 0.675163C1.06342 0.3475 0.551909 0.3475 0.236191 0.675163C-0.0787316 1.00283 -0.0787316 1.53452 0.236191 1.86219L7.42896 9.32956C7.74062 9.65226 8.26017 9.65226 8.57104 9.32874Z" fill="currentColor" />
                                    </svg>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="credits-detail-page-inner-right">
                        <div className="credits-item-wrap">
                            {
                                creditsByMerchant.length > 0 ?
                                    <div className="credits-item-inner">
                                        <div className="credits-item-top relative mb-2">
                                            <div className="credits-item-img">
                                                <img loading="lazy" src={creditsByMerchant[0].store_credit_image} alt="" className="rounded-lg w-full" />
                                            </div>
                                            <div className="credits-item-logo absolute bottom-2 left-2">
                                                <img loading="lazy" src="assets/images/prod_logo_1.png" alt="" />
                                            </div>
                                            <div
                                                className="credits-item-price py-1 px-2 rounded-md bg-[#FFE940] text-base font-Rany font-bold inline-block absolute top-2 right-2">
                                                earn {creditsByMerchant[0].store_credit_percentage}%
                                            </div>
                                        </div>
                                        <div className="credits-item-bottom mb-4">
                                            <div className="credits-item-title text-2xl text-[#0F0F0F] font-Rany font-bold">
                                                {creditsByMerchant[0].merchant_store_name}
                                            </div>
                                            <div className="credits-item-desc text-sm text-[#495057]">
                                                {creditsByMerchant[0].merchant_business_description}
                                            </div>
                                        </div>
                                    </div> : ''
                            }
                        </div>
                        <button onClick={() => redeem()} className="form-btn bg-[#0F0F0F] rounded-lg disabled:opacity-40 text-white mb-4 w-full p-4 hover:opacity-90 flex gap-2 items-center justify-center">
                            Redeem
                            <svg className="h-3 w-3 text-[#fff]" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.6575 1.34303C13.6575 0.790745 13.2097 0.34303 12.6575 0.343029L3.65746 0.34303C3.10517 0.34303 2.65746 0.790745 2.65746 1.34303C2.65746 1.89531 3.10517 2.34303 3.65746 2.34303L11.6575 2.34303L11.6575 10.343C11.6575 10.8953 12.1052 11.343 12.6575 11.343C13.2097 11.343 13.6575 10.8953 13.6575 10.343L13.6575 1.34303ZM2.05086 13.3638L13.3646 2.05014L11.9504 0.635923L0.636643 11.9496L2.05086 13.3638Z" fill="currentColor" />
                            </svg>
                        </button>
                        <div
                            className="shadow-md shadow-slate-400 rounded-lg  p-4 flex gap-4 justify-between items-center">
                            <div className="text-base text-[#0F0F0F] font-bold font-Rany">
                                Current balance
                            </div>
                            <div className="py-1 px-10 rounded-md bg-[#FFE940] text-base font-Rany font-bold inline-block">
                                <AmountConverter amount={currentBalance} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='lg:hidden'>
                <div className="credits-detail-page max-w-[710px] mx-auto py-5 pt-5 flex flex-col  lg:h-full">
                    <div className="credits-detail-page-inner grid grid-cols-1 lg:grid-cols-2 gap-5 lgh-full">
                        <div className="credits-detail-page-inner-left h-full flex flex-col">
                            <div
                                className="page-title text-[32px] font-Rany font-bold grow-0 shrink-0 flex gap-4 items-center pb-4 lg:p-2 lg:pt-0 -mt-2">
                                <GoBack />
                                All Credits
                            </div>
                            <div className="credits-item-wrap">
                                {
                                    creditsByMerchant.length > 1 ?
                                        <div className="credits-item-inner">
                                            <div className="credits-item-top relative mb-2">
                                                <div className="credits-item-img">
                                                    <img loading="lazy" src={creditsByMerchant[0].store_credit_image} alt="" className="rounded-lg w-full" />
                                                </div>
                                                <div className="credits-item-logo absolute bottom-2 left-2">
                                                    <img loading="lazy" src="assets/images/prod_logo_1.png" alt="" />
                                                </div>
                                                <div
                                                    className="credits-item-price py-1 px-2 rounded-md bg-[#FFE940] text-base font-Rany font-bold inline-block absolute top-2 right-2">
                                                    earn {creditsByMerchant[0].store_credit_percentage}%
                                                </div>
                                            </div>
                                            <div className="credits-item-bottom mb-4">
                                                <div className="credits-item-title text-2xl text-[#0F0F0F] font-Rany font-bold">
                                                    {creditsByMerchant[0].merchant_store_name}
                                                </div>
                                                <div className="credits-item-desc text-sm text-[#495057]">
                                                    {creditsByMerchant[0].merchant_business_description}
                                                </div>
                                            </div>
                                        </div> : ''
                                }
                            </div>
                            <button onClick={() => redeem()} className="form-btn bg-[#0F0F0F] rounded-lg disabled:opacity-40 text-white mb-4 w-full p-4 hover:opacity-90 flex gap-2 items-center justify-center">
                                Redeem
                                <svg className="h-3 w-3 text-[#fff]" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.6575 1.34303C13.6575 0.790745 13.2097 0.34303 12.6575 0.343029L3.65746 0.34303C3.10517 0.34303 2.65746 0.790745 2.65746 1.34303C2.65746 1.89531 3.10517 2.34303 3.65746 2.34303L11.6575 2.34303L11.6575 10.343C11.6575 10.8953 12.1052 11.343 12.6575 11.343C13.2097 11.343 13.6575 10.8953 13.6575 10.343L13.6575 1.34303ZM2.05086 13.3638L13.3646 2.05014L11.9504 0.635923L0.636643 11.9496L2.05086 13.3638Z" fill="currentColor" />
                                </svg>
                            </button>
                            <div
                                className="shadow-md shadow-slate-400 rounded-lg  p-4 flex gap-4 justify-between items-center">
                                <div className="text-base text-[#0F0F0F] font-bold font-Rany">
                                    Current balance
                                </div>
                                <div className="py-1 px-10 rounded-md bg-[#FFE940] text-base font-Rany font-bold inline-block">
                                    <AmountConverter amount={currentBalance} />
                                </div>
                            </div>

                        </div>
                        <div className="credits-detail-page-inner-right">
                            <div className="flex gap-4 lg:p-2 flex-col">
                                {creditsByMerchant.map((item, index) => (
                                    <CreditProductCard key={'credit_' + index} onButtonClick={() => openOrderDetail(item)} order={item} />
                                ))}
                            </div>
                            <div className="shrink-0 text-center pt-6 grow-0 mb-4">
                                {creditsByMerchant.length < totalRow &&
                                    <div onClick={() => loadNextPage()}
                                        className="bg-[#E9ECEF] py-1 px-3 cursor-pointer inline-flex gap-2 items-center rounded-lg hover:bg-[#6C757D] hover:text-white">
                                        See more
                                        <svg className="h-2 w-4" width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.57104 9.32874L15.7638 1.86136C16.0787 1.53369 16.0787 1.00283 15.7638 0.674336C15.4489 0.346673 14.9374 0.346673 14.6225 0.674336L8.0004 7.54941L1.37835 0.675163C1.06342 0.3475 0.551909 0.3475 0.236191 0.675163C-0.0787316 1.00283 -0.0787316 1.53452 0.236191 1.86219L7.42896 9.32956C7.74062 9.65226 8.26017 9.65226 8.57104 9.32874Z" fill="currentColor" />
                                        </svg>
                                    </div>
                                }
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CreditDetail;
